module.exports = __webpack_public_path__ + "static/img/3.c2498af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/3.jpg
// module id = K+RN
// module chunks = 6